(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bafde-native-localization"] && !Shopify.designMode) return;
  try {
    const bafdeLocalization = document.getElementById('BafdeLocalization');
  if (bafdeLocalization) {
    bafdeLocalization.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        bafdeLocalization.open = false;
        bafdeLocalization.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (bafdeLocalization.open && !bafdeLocalization.contains(event.target)) bafdeLocalization.open = false;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
